import React from 'react';
import styled from 'styled-components';
import { FaGamepad, FaShoppingCart, FaEthereum } from 'react-icons/fa';

const MonetizationSection = styled.section`
  background: linear-gradient(135deg, #121220 0%, #0a0a12 100%);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  color: var(--secondary);
  position: relative;
  padding-bottom: 1rem;
  display: inline-block;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 4px;
    background: linear-gradient(90deg, var(--primary), var(--secondary));
    border-radius: 2px;
  }
`;

const Subtitle = styled.p`
  max-width: 800px;
  margin: 0 auto;
  color: var(--text-secondary);
  font-size: 1.1rem;
  line-height: 1.6;
`;

const StrategiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
`;

const StrategyCard = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 2.5rem;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);

  &:hover {
    transform: translateY(-10px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border-color: rgba(24, 202, 230, 0.3);
  }
`;

const IconWrapper = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary), var(--secondary));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  color: white;
`;

const StrategyTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--secondary);
`;

const StrategyDescription = styled.p`
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 1rem;
`;

const Monetization = () => {
  const strategies = [
    {
      icon: <FaGamepad />,
      title: "Gameplay Expansion",
      description: "Introducing new mechanics, environments, and AI character types to drive paid content growth and enhance the player experience.",
      details: "Regular updates will include new revelation types, environments, and challenges to keep the game fresh and engaging."
    },
    {
      icon: <FaShoppingCart />,
      title: "Standalone Version",
      description: "Developing an independent edition with a buy-to-play model, offering a complete game experience with premium features.",
      details: "The standalone version will include exclusive content, advanced AI features, and enhanced graphics."
    },
    {
      icon: <FaEthereum />,
      title: "Web3 Integration",
      description: "Exploring blockchain adaptation with NFT assets and token-based monetization for a new dimension of ownership and rewards.",
      details: "Players can own unique in-game assets as NFTs and participate in a token economy that rewards strategic gameplay."
    }
  ];

  return (
    <MonetizationSection id="monetization">
      <Container>
        <SectionHeader>
          <Title>Monetization Strategies</Title>
          <Subtitle>
            Our approach to monetization focuses on creating value for players while sustaining ongoing development.
          </Subtitle>
        </SectionHeader>

        <StrategiesGrid>
          {strategies.map((strategy, index) => (
            <StrategyCard key={index}>
              <IconWrapper>{strategy.icon}</IconWrapper>
              <StrategyTitle>{strategy.title}</StrategyTitle>
              <StrategyDescription>{strategy.description}</StrategyDescription>
              <StrategyDescription>{strategy.details}</StrategyDescription>
            </StrategyCard>
          ))}
        </StrategiesGrid>
      </Container>
    </MonetizationSection>
  );
};

export default Monetization;
